/**
 * Owner: Masa Bayu
 * File: AdminMoneyList.tsx
 * Date:Time: 2026-10-23 10:40
 * Description: §467-D — satu senarai hasil per mata wang (satu SSOT paparan).
 *   Hasil TIDAK pernah dijumlah rentas kod mata wang: setiap baris membawa
 *   jumlah minor-unit + kiraan order bagi kod itu sahaja.
 */

import type { ReactElement } from 'react';
import type { AdminLabels } from './admin-labels';
import type { HubMoney } from './admin-dashboard';
import { moneyOf } from './admin-view';

export interface AdminMoneyListProps {
  readonly rows: readonly HubMoney[];
  readonly la: AdminLabels;
  /** null = kiraan order tidak diminta (paparan kod + jumlah sahaja). */
  readonly showOrders?: boolean;
}

export function AdminMoneyList({ rows, la, showOrders = true }: AdminMoneyListProps): ReactElement {
  if (rows.length === 0) {
    return <p className="qxa__empty">{la.noData}</p>;
  }
  return (
    <ul className="qxa__money-list">
      {rows.map((row) => (
        <li key={row.currency} className="qxa__money-row">
          <span className="qxa__money-code">{row.currency}</span>
          <span className="qxa__money-value">{moneyOf(row, la.noData)}</span>
          {showOrders ? (
            <span className="qxa__money-orders">
              {String(row.orders)} · {la.kpiPaidOrders}
            </span>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
